import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  list: {
    marginTop: 16,
    background: 'white',
    padding: 20,
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    width: '100%',
  },

  notFound: {
    textAlign: 'center',
    padding: '24px 0',
  },

  buttonViewMore: {
    fontSize: 32,
  },

  invoiceStatus: {
    color: '#ffff',
    padding: '2px 4px',
    borderRadius: 8,
    textTransform: 'uppercase',
    fontWeight: 600,

    '&.paga': {
      backgroundColor: theme.palette.secondary.main,
    },

    '&.reembolso, &.reembolsado': {
      backgroundColor: theme.palette.error.main,
    },

    '&.aberta': {
      backgroundColor: theme.palette.primary.light,
    },

    '&.aberta-blue': {
      backgroundColor: '#2d86ca',
    },

    '&.recuperacao': {
      backgroundColor: '#fabb0a',
    },

    '&.negociada': {
      backgroundColor: theme.palette.error.main,
    },
  },

  status: {
    fontSize: 10,
    whiteSpace: 'nowrap',
    marginTop: 2,
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      marginLeft: 8,
    },
  },

  httpStatus: {
    color: '#ffff',
    padding: '0 0.2rem',
    borderRadius: 4,

    '&.status-504': {
      backgroundColor: theme.palette.error.main,
    },

    '&.status-200': {
      backgroundColor: '#009358',
    },
  },

  invoice: {
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      width: 16,
      fill: theme.palette.primary.light,
      marginLeft: 5,
    },
  },

  icon: {
    lineHeight: 0,
  },

  copy: {
    display: 'flex',
    alignItems: 'center',

    '& span.material-icons': {
      fontSize: 16,
      marginLeft: 8,
      cursor: 'pointer',
    },
  },
}));

export default styles;
